module.exports = __webpack_public_path__ + "img/HIA_Logo-white.d6a5796a.png";